import React from 'react'
import { Builder } from '@builder.io/react'
import CdnImage from 'components/util/CdnImage'
import dayjs from 'dayjs'
import { graphql, useStaticQuery } from 'gatsby'
import LinkRoute from '../../ui/link/Link'

import './index.css'

interface Props {
  category: {
    id: string
  }
  backgroundColor: string
  blogItemBackgroundColor: string
  blogItemTitleColor: string
  blogItemDescriptionColor: string
  authorNameColor: string
  articleDateColor: string
}

const BlogCategoryLister = ({
  backgroundColor,
  blogItemBackgroundColor,
  blogItemTitleColor,
  blogItemDescriptionColor,
  authorNameColor,
  articleDateColor,
  category
}: Props) => {
  const { allBuilderModels }: any = useStaticQuery(graphql`
    query {
      allBuilderModels {
        blogArticle (options: { enrich: true }) {
          data {
            category
            date
            title
            url
            description
            coverImage
            cdnCoverImage
            author
          }
        }
        author {
          data {
            authorName
            photo
          }
          id
        }
      }
    }
  `)

  console.log('--- Blog Category Lister - Category ---', category)
  console.log('--- Blog Lister - BlogArticles ---', allBuilderModels.blogArticle)
  console.log('--- Blog Lister - BlogAuthors ---', allBuilderModels.author)

  const dateFormatted = (date: any) => {
    const dateObj = new Date(date)
    const dateStr = dayjs(dateObj).format('D MMMM YYYY') // dateObj.toLocaleDateString(getLang())
    return dateStr
  }

  const renderBlogs = () => {
    const blogArticles = allBuilderModels.blogArticle
    return blogArticles
      .filter((item: any) => (category?.id ? item.data.category?.id === category.id : true))
      .map((item: any, i: number) => {
        const post = item.data
        const authorId = post.author.id
        const author = allBuilderModels.author?.filter((autho: any) => autho.id === authorId)[0]
        return (
          <div
            key={i}
            className="relative flex flex-col overflow-hidden rounded-3xl"
            style={{ backgroundColor: backgroundColor }}
          >
            <div className="flex-shrink-0">
              <>
                {post.cdnCoverImage ? (
                  <CdnImage
                    className="h-48 w-full object-cover"
                    url={post.cdnCoverImage}
                    alt={post.title}
                    steps={[414]}
                  />
                ) : (
                  <img className="h-48 w-full object-cover" src={post.coverImage} alt={post.title} />
                )}
              </>
            </div>
            <div
              className="flex flex-1 flex-col justify-between p-6"
              style={{ backgroundColor: blogItemBackgroundColor }}
            >
              <div className="flex-1">
                <LinkRoute href={post.url} className="mt-2 block" target="_blank" style={{ textDecoration: 'none' }}>
                  <p className="mt-3 mb-4 text-base text-gray-500" style={{ color: blogItemDescriptionColor }}>
                    {post.description}
                  </p>
                  <h5
                    className="text-xl font-semibold text-gray-900 hover:underline"
                    style={{ color: blogItemTitleColor }}
                  >
                    {post.title}
                  </h5>
                  <span className="absolute inset-0" />
                </LinkRoute>
              </div>
              <div className="mt-6 flex items-center">
                <div className="flex-shrink-0">
                  <span className="sr-only">{author?.data?.name}</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-900" style={{ color: authorNameColor }}>
                    {author?.data?.name}
                  </p>
                  <div className="flex space-x-1 text-base text-gray-500" style={{ color: articleDateColor }}>
                    <span>{dateFormatted(post.date)}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      })
  }

  return (
    <div className={`relative px-8 pt-0 pb-4 sm:px-4 lg:px-8  lg:pb-8`} style={{ backgroundColor }}>
      <div className={`relative mx-auto max-w-7xl md:block`}>
        <div className="mx-auto mt-8 grid max-w-lg gap-5 lg:max-w-none lg:grid-cols-3">{renderBlogs()}</div>
      </div>
    </div>
  )
}

export default BlogCategoryLister

Builder.registerComponent(BlogCategoryLister, {
  name: 'BlogCategoryLister',
  inputs: [
    { name: 'category', type: 'reference', model: 'blog-category', description: 'Filter blog articles by category' },
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: '#F9F5F1'
    },
    {
      name: 'blogItemBackgroundColor',
      type: 'color',
      defaultValue: '#cfcfcf'
    },
    {
      name: 'blogItemTitleColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'blogItemDescriptionColor',
      type: 'color',
      defaultValue: 'brown'
    },
    {
      name: 'authorNameColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'articleDateColor',
      type: 'color',
      defaultValue: 'gray'
    }
  ]
})
